// extracted by mini-css-extract-plugin
module.exports = {"root":"DesktopSearchWidgetWrapper_root__GHxbY"};